<template>
  <div class="col-lg-4 col-md-4 col-sm-12">
    <div class="card timeCard">
      <div
        :hasOT="hasOT"
        :class="hasOT ? 'card-header-ot-alert' : null"
        class="card-header bg-teal-400 d-flex justify-content-between"
      >
        <span
          class="font-size-sm text-uppercase font-weight-semibold timeCarDate"
        >
          {{ date }}
        </span>
        <div>
          <WeeklyOT
            ref="weeklyOT"
            @change-header="updateTimeCardHeader"
            @setWeeklyHours="setWeeklyHours"
            :id="id"
            :date="date"
            :uid="uid"
            :name="name"
            style="display: none"
          ></WeeklyOT>
          <span
            class="font-size-sm text-uppercase font-weight-semibold float-left"
          >
            {{ name }}
          </span>
          <div class="breadcrumb-elements-item dropdown p-0 float-right">
            <a href="#/" class="timeCardSettings ml-2">
              <i
                class="icon-info3"
                @click="
                  () => {
                    showInfoModal = true;
                  }
                "
              ></i>
            </a>
            <a
              v-if="mapMarkerLocations.length >= 1"
              href="#"
              class="timeCardSettings ml-2"
              @click.prevent="mapDialogOpen = true"
            >
              <i class="icon-pin"></i>
            </a>
            <a href="#" class="timeCardSettings ml-2" data-toggle="dropdown">
              <i class="icon-gear"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right">
              <a
                href="#/"
                class="dropdown-item"
                v-on:click="editTimeCard"
                v-bind:class="name == storedUser ? 'disabled' : ''"
              >
                <i class="icon-pencil"></i>
                Edit Time Card
              </a>
              <a href="#/" class="dropdown-item" v-on:click="deleteTimeCard">
                <i class="icon-bin2"></i>
                Delete Time Card
              </a>
              <a
                href="#/"
                class="dropdown-item"
                v-on:click="addNewComment"
              >
                <i class="icon-comment"></i>
                Add Comment
              </a>
            </div>
            <el-tooltip placement="top" class="ml-2" v-if="hasOT">
              <div slot="content">
                The employee has exceeded the number of regular hours this week
              </div>
              <i class="icon-help"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <!-- kiefer -->
      <div class="card-body">
        <span
          class="badge badge-warning mb-2 cursor-pointer"
          v-if="editComment != null"
          v-on:click="showComment = true"
        >
          View time card notes
        </span>
        <div class="d-flex justify-content-between">
          <table class="text-center w-100">
            <tr>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Type</th>
              <th v-if="jobSpecificTimes">Job</th>
              <th>Notes</th>
            </tr>
            <tbody>
              <tr v-for="(time, index) in formattedTimes" v-bind:key="index">
                <td>
                  {{ time.startTime }}
                </td>
                <td
                  v-if="
                    index == formattedTimes.length - 1 && tempIncomplete == true
                  "
                >
                  --
                </td>
                <td v-else>
                  {{ time.endTime }}
                </td>

                <td>
                  {{ time.type }}
                </td>
                <td v-if="jobSpecificTimes">
                  <el-tooltip
                    v-if="time.job"
                    class="item"
                    effect="dark"
                    placement="top"
                    data-html="true"
                  >
                    <div slot="content" v-html="getJobName(time.job)"></div>
                    <i class="icon-circle-small"></i>
                  </el-tooltip>
                </td>
                <td>
                  <el-tooltip
                    v-show="
                      time.notes != undefined &&
                        time.notes != null &&
                        time.notes.trim() != ''
                    "
                    class="item"
                    effect="dark"
                    placement="top"
                    data-html="true"
                  >
                    <div slot="content" v-html="time.notes"></div>
                    <i class="icon-bubble"></i>
                  </el-tooltip>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <div class="d-flex justify-content-end pt-4">
            <div class="d-flex flex-column">
              <div class="d-flex justify-content-end mr-5 font-weight-bold">
                <p class="mr-2">Total Hours:</p>
                <p v-if="incomplete">--</p>
                <p v-else>{{ total }}</p>
              </div>
              <div class="d-flex justify-content-end mr-5 font-weight-bold">
                <p class="mr-2">Regular Hours:</p>
                <p v-if="incomplete">--</p>
                <p v-else>{{ regularHours}}</p>
              </div>
              <div
                v-if="jobSpecificTimes && averagingAgreement"
                class="d-flex flex-column"
              >
                <div
                  v-for="(value,
                  name,
                  index) in jobSpecificHoursSummary.regular"
                  :key="index"
                >
                  <div v-if="!incomplete">
                    <div v-if="value > 0" class="d-flex justify-content-end">
                      <i class="icon-circle-small"></i>
                      <p class="mr-2">{{ `${getJobName(name)}:` }}</p>
                      <p>{{ value }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="otHours > 0"
                class="d-flex justify-content-end mr-5 font-weight-bold"
              >
                <p class="mr-2">OT Hours:</p>
                <p v-if="incomplete">--</p>
                <p v-else>{{ otHours }}</p>
              </div>
              <div
                v-if="jobSpecificTimes && averagingAgreement"
                class="d-flex flex-column"
              >
                <div
                  v-for="(value, name, index) in jobSpecificHoursSummary.ot"
                  :key="index"
                >
                  <div v-if="!incomplete">
                    <div v-if="value > 0" class="d-flex justify-content-end">
                      <i class="icon-circle-small"></i>
                      <p class="mr-2">{{ `${getJobName(name)}:` }}</p>
                      <p>{{ value }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="onCallHours > 0"
                class="d-flex justify-content-end mr-5"
              >
                <p class="mr-2">On Call Hours:</p>
                <p v-if="incomplete">--</p>
                <p v-else>{{ onCallHours }}</p>
              </div>
              <div
                v-if="travelTime > 0"
                class="d-flex justify-content-end mr-5"
              >
                <p class="mr-2">Travel Hours:</p>
                <p v-if="incomplete">--</p>
                <p v-else>{{ travelTime }}</p>
              </div>
              <div
                v-if="statTime > 0 || statError"
                class="d-flex justify-content-end mr-5"
              >
                <p class="mr-2">Stat Hours:</p>
                <p v-if="incomplete">--</p>
                <p v-else>{{ statError ? statError : statTime }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <table class="mt-4 float-right">
          <tr>
            <td class="">
              Total Hours:
            </td>
            <td v-if="incomplete" class="">
              --
            </td>
            <td v-else class="">
              {{ total }}
            </td>
            <td></td>
          </tr>
          <tr>
            <td class="text-decoration-underline">
              Regular Hours:
            </td>
            <td v-if="incomplete">
              --
            </td>
            <td v-else>
              {{ regularHours }}
            </td>
          </tr>
          <div
            v-if="jobSpecificTimes && averagingAgreement"
            class="float-right"
          >
            <tr
              v-for="(value, name, index) in jobSpecificHoursSummary.regular"
              :key="index"
            >
              <td class="pr-5"></td>
              <td class="pr-2">{{ `${getJobName(name)}:` }}</td>
              <td class="pr-4">{{ value }}</td>
            </tr>
          </div>

          <tr>
            <td>
              OT Hours:
            </td>
            <td v-if="incomplete">
              --
            </td>
            <td v-else>
              {{ otHours }}
            </td>
          </tr>
          <tr v-if="onCallHours > 0">
            <td>
              On Call Hours:
            </td>
            <td v-if="incomplete">
              --
            </td>
            <td v-else>
              {{ onCallHours }}
            </td>
          </tr>
          <tr v-if="travelTime > 0">
            <td>
              Travel Time
            </td>
            <td v-if="incomplete">
              --
            </td>
            <td v-else>
              {{ travelTime }}
            </td>
          </tr>
          <tr v-show="statTime > 0">
            <td>
              Stat Pay
            </td>
            <td v-if="incomplete">
              --
            </td>
            <td v-else>
              {{ statTime }}
            </td>
          </tr>
        </table> -->
      </div>

      <div class="card-footer bg-light d-flex justify-content-between">
        <span v-if="!approvedVals.approved" class="opacity-75">
          Not approved
        </span>
        <span v-if="approvedVals.approved" class="opacity-75">
          <i
            class="icon-user-check approvedInfo"
            data-toggle="tooltip"
            v-bind:title="approvedBy"
          ></i>
          <br />
          Approved On: {{ approvedVals.dateApproved }}
        </span>

        <ul class="list-inline mb-0">
          <el-tooltip
            content="Incomplete time cards cannot be approved"
            effect="dark"
            placement="top"
            data-html="true"
            :disabled="!incomplete"
          >
            <div :class="incomplete ? 'wrapper' : ''">
              <li
                v-on:click="updateApproved"
                class="list-inline-item"
                :class="incomplete ? 'disabled' : ''"
              >
                <i
                  v-bind:class="[
                    approvedVals.approved == true
                      ? 'icon-checkmark3 approvedCheck approvedIcon'
                      : 'icon-checkbox-unchecked2 approvedIcon'
                  ]"
                ></i>
              </li>
            </div>
          </el-tooltip>
        </ul>
      </div>
    </div>
    <TimeCardDetails
      @closeModal="closeModal()"
      :showInfoModal="showInfoModal"
      :id="id"
      :date="date"
      :approved="approved"
      :times="times"
      :name="name"
      :type="type"
      :category="category"
      :dateApproved="dateApproved"
      :approvedBy="approvedBy"
      :lastRegTime="Number(lastRegTime)"
      :otIndex="otIndex"
      :index="index"
      :holidays="holidays"
      :vacation="vacation"
      :incomplete="incomplete"
      :uid="uid"
      :showLocation="showLocation"
      :passedEditComment="passedEditComment"
      :averagingAgreement="averagingAgreement"
      :formattedTimes="formattedTimes"
      :otHours="Number(otHours)"
      :regularHours="Number(regularHours)"
      :statTime="Number(statTime)"
      :statHoursCount="Number(statHoursCount)"
      :statDaysCount="Number(statDaysCount)"
      :statExemptDaysTotal="Number(statExemptDaysTotal)"
      :statExemptHoursTotal="Number(statExemptHoursTotal)"
      :travelTime="Number(travelTime)"
      :onCallhours="Number(onCallHours)"
      :total="Number(total)"
      :averagingAgreementData="averagingAgreementData"
      :agreementTotalHours="agreementTotalHours"
      :weeklyHours="Number(weeklyHours)"
      :stat="stat"
      :automationsApplied="automationsApplied"
      :agreementTimeSpanIndex="agreementTimeSpanIndex"
    ></TimeCardDetails>

    <!-- Edit Time Card Modal -->
    <modal-wrapper :isOpen="showEditModal">
      <div
        v-if="showEditModal"
        id="editUser"
        class="customModal fade"
        v-bind:class="{ show: showEditModal }"
      >
        <div class="modal-dialog modal-md">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h6 class="modal-title">{{modalName}}</h6>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                v-on:click="handleModalClose()"
              >
                &times;
              </button>
            </div>
            <div class="modal-body">
              <div>
                <div class="row mb-3">
                  <div class="col-6">
                    <h3 class="float-left">{{ name }}</h3>
                  </div>
                  <div class="col-6">
                    <h6 class="float-right">{{ date }}</h6>
                  </div>
                </div>
                <div v-if="!addComment.showCommentScreen">
                  <div
                    class="row"
                    v-for="(time, index) in tempTimes"
                    v-bind:key="index"
                  >
                    <div :class="jobSpecificTimes ? 'col-6' : 'col-8'">
                      <div class="form-group">
                        <label>Time Range:</label>
                        <el-date-picker
                          v-model="time.times"
                          type="datetimerange"
                          start-placeholder="Start Date"
                          end-placeholder="End Date"
                          :default-value="date"
                          :default-time="
                            time.times ? formatUtcToMST(time.times) : null
                          "
                          :picker-options="pickerOptions"
                          prefix-icon="null"
                          :ref="'datetime_' + index"
                          @blur="dateChanged"
                          :clearable="false"
                          
                        ></el-date-picker>
                        <!-- @change="
                            newTimesRange => validateTimeSlot(newTimesRange, index)
                          " -->
                        <div class="date-errors position-absolute d-flex">
                    <div v-if="time.dateError" class="small">
                      <span>{{ time.dateMessage }}</span>
                    </div>
                    <div v-if="time.timeOverlap" class="text-danger small">
                      <span>{{ time.timeOverlap }}</span>
                    </div>
                  </div>
                      </div>
                    </div>
                    <div :class="jobSpecificTimes ? 'col-2' : 'col-3'">
                      <div class="form-group">
                        <label>Type:</label>
                        <v-select
                          :options="timeSpanTypes"
                          v-model="time.type"
                        ></v-select>
                        <div v-if="time.typeError">
                          <span>{{ time.typeMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="jobSpecificTimes" class="col-3">
                      <div class="form-group">
                        <label>Job:</label>
                        <v-select
                          :options="jobs"
                          label="description"
                          v-model="time.job"
                          :reduce="description => description.id"
                        ></v-select>
                        <div v-if="time.jobError">
                          <span>{{ time.jobMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-1 mt-auto">
                      <el-dropdown class="inlineButton mb-3">
                        <el-button type="primary">
                          <i class="el-icon-arrow-down"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            v-if="showIncompleteTimeCards == 'Yes'"
                            @click.native="removeEndTime(index)"
                            v-bind:disabled="
                              index < tempTimes.length - 1 ||
                                isEndTimeEmpty(index)
                            "
                          >
                            <i class="icon-calendar"></i>
                            Remove end time
                          </el-dropdown-item>
                          <el-dropdown-item
                            @click.native="removeTime(index)"
                            v-bind:disabled="
                              tempTimes.length === 1 ? true : false
                            "
                          >
                            <i class="icon-trash-alt"></i>
                            Delete time span
                          </el-dropdown-item>
                          <el-dropdown-item
                            @click.native="splitTimeCard(index)"
                            :disabled="isEndTimeEmpty(index)"
                          >
                            >
                            <i class="icon-unfold"></i>
                            Split time span
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </div>
                <div v-if="showEditAlert">
                  <span id="span_editUser_alertDetail">
                    {{ editTimeCardMessage }}
                  </span>
                </div>
                <div class="row" v-if="!addComment.showCommentScreen">
                  <div class="col-12">
                    <button
                      type="button"
                      class="btn bg-primary"
                      v-on:click="addTime()"
                      :disabled="
                        tempTimes[tempTimes.length - 1].times
                          ? tempTimes[tempTimes.length - 1].times[0] &&
                            tempTimes[tempTimes.length - 1].times[1]
                            ? false
                            : true
                          : tempTimes[tempTimes.length - 1].startTime &&
                            tempTimes[tempTimes.length - 1].endTime
                          ? false
                          : true
                      "
                    >
                      <i class="icon-plus3 mr-2"></i>
                      Add Time
                    </button>
                  </div>
                </div>
                <div v-if="addComment.showCommentScreen">
                  <div class="form-group" style="display: grid">
                    <div
                      v-for="(comment, index) in tempComments"
                      v-bind:key="index"
                    >
                      <div
                        class="mb-2 d-inline-grid text-left"
                        v-bind:class="
                          comment.commentBy == storedUser
                            ? 'float-right speech-bubble-mine'
                            : 'float-left speech-bubble'
                        "
                      >
                        <span>
                          <strong>{{ comment.commentBy }}:</strong>
                        </span>
                        <span>{{ comment.commentDate }}</span>
                        <p class="mt-2">
                          {{ comment.comment }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div
                v-if="addComment.showCommentScreen"
                class="row mt-3"
                style="margin: auto; margin-left: 0px"
              >
                <div class="col-12">
                  <label class="">{{ editCommentReasonTitle }}</label>
                </div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="comment..."
                    v-model="addComment.comment"
                    v-on:keyup="checkforEnter"
                  />
                </div>
                <div class="col-2">
                  <button
                    type="button"
                    class="btn bg-primary"
                    v-on:click="addCommentToList()"
                  >
                    Add
                  </button>
                </div>
                <label
                  class="validation-invalid-label"
                  for="basic"
                  v-bind:class="!addComment.error ? 'hidden' : null"
                >
                  {{ addComment.errorMessage }}
                </label>
              </div>
              <div class="row">
                <button
                  type="button"
                  class="btn btn-link"
                  data-dismiss="modal"
                  v-on:click="handleModalClose()"
                >
                  Close
                </button>
                <button
                  type="button"
                  class="btn bg-primary"
                  v-on:click="switchToComment()"
                  v-if="!addComment.showCommentScreen && timeCardEdited"
                >
                  Next
                </button>
                <!-- 
                  :disabled="isTimeOverlaped"

                 -->
                <button
                  type="button"
                  class="btn bg-primary"
                  v-on:click="submitTimeCardEdit()"
                  v-if="addComment.showCommentScreen"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal-wrapper>
    <!-- /Edit Time Card Modal -->

    <!-- Delete Time Card Modal -->
    <el-dialog
      title="Confirm"
      :visible.sync="deleteVisible"
      width="30%"
      custom-class="confirmModal"
    >
      <span>Are you sure you want to delete this time card?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">Cancel</el-button>
        <el-button type="primary" @click="confirmDeleteTimeCard">
          Confirm
        </el-button>
      </span>
    </el-dialog>
    <!-- /Delete Time Card Modal -->

    <!-- Close Edit Card Modal -->
    <el-dialog
      title="Confirm"
      :visible.sync="showCloseConfirmation"
      width="30%"
      custom-class="confirmModal"
    >
      <div>Are you sure you want to close card editing?</div>
      <div>Your changes will be lost.</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCloseConfirmation = false">Cancel</el-button>
        <el-button type="primary" @click="closeModal()">Confirm</el-button>
      </span>
    </el-dialog>
    <!-- Close Edit Card Modal -->

    <!-- Map Dialog -->
    <el-dialog
      v-if="mapMarkerLocations.length >= 1"
      title="User Location"
      :visible.sync="mapDialogOpen"
      custom-class="confirmModal"
    >
      <l-map
        :zoom="9"
        :center="mapMarkerLocations[0].marker"
        style="height: 400px"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker
          v-for="(marker, index) in mapMarkerLocations"
          v-bind:key="index"
          :lat-lng="marker.marker"
          :icon="getIcon(marker)"
        >
          <l-tooltip :options="{ permanent: true, interactive: true }">
            <div>
              {{ marker.name }}
            </div>
          </l-tooltip>
        </l-marker>
      </l-map>
    </el-dialog>
    <!-- /Map Dialog -->

    <!-- View Notes Modal -->
    <el-dialog
      title="Notes"
      :visible.sync="showComment"
      width="30%"
      custom-class="confirmModal commentsModal scroll_dialog"
      :show-close="true"
      height="5%"
    >
      <div
        v-for="(comment, index) in editComment"
        v-bind:key="index"
        v-bind:class="
          comment.commentBy == storedUser ? 'float-right' : 'float-left'
        "
      >
        <div
          class="mb-2 d-inline-grid text-left"
          v-bind:class="
            comment.commentBy == storedUser
              ? 'float-right speech-bubble-mine'
              : 'float-left speech-bubble'
          "
        >
          <span>
            <strong>{{ comment.commentBy }}:</strong>
          </span>
          <span>{{ comment.commentDate }}</span>
          <p class="mt-2">
            {{ comment.comment }}
          </p>
        </div>
      </div>
    </el-dialog>
    <!-- /View Notes Modal -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { db } from '../assets/js/firebase/db.js';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import {
  regularTime,
  otTime,
  overRideValues,
  parseTimeCards,
  totalTime,
  roundToQuarter
} from '../assets/js/helpers/hoursCalculations.js';
import Vue from 'vue';
import { latLng } from 'leaflet';
import { LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
//kiefer - workaround to broken marker image on leaflet map
import 'leaflet/dist/leaflet.css';
import * as L from 'leaflet';
import WeeklyOT from './childComponents/weeklyOT.vue';
import TimeCardDetails from './childComponents/timeCardDetails.vue';
import { EventBus } from '../main';
import ModalWrapper from './modalWrapper.vue';
delete L.Icon.Default.prototype._getIconUrl;
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
//this represents Monday-Saturday being disbled in the time pickers.
// let disabledDays = [];
//kiefer - workaround to broken marker image on leaflet map
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
export default {
  name: 'timeCard',
  components: {
    WeeklyOT,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    TimeCardDetails,
    ModalWrapper
  },
  props: {
    id: null,
    date: null,
    approved: null,
    times: null,
    name: null,
    type: null,
    category: null,
    dateApproved: null,
    approvedBy: null,
    lastRegTime: null,
    otIndex: null,
    index: null,
    timeSpanTypes: null,
    holidays: null,
    vacation: null,
    incomplete: null,
    uid: null,
    showLocation: null,
    passedEditComment: null,
    averagingAgreement: Object,
    users: Array,
    automationsApplied: Array
  },
  data() {
    var vm = this;
    return {
      stat: false,
      statError: null,
      weeklyHours: null,
      averagingAgreementData: null,
      agreementTimeSpanIndex: null,
      agreementTotalHours: {},
      showInfoModal: false,
      hasOT: false,
      showEditModal: false,
      deleteVisible: false,
      showEditAlert: false,
      editTimeCardMessage: null,
      timeSpanRestrictions: [],
      //there is a difference between a shallow and deep copy of a variable. A shallow copy will still keep the bind between the variables. This is similar to
      //just setting the variables equal to eachother. This is what is considered a deep copy and there is no binding. This makes a true local copy for editting
      //the variable before the edit is submitted.
      tempTimes: JSON.parse(JSON.stringify(this.times)),
      // tempComments: JSON.parse(JSON.stringify(this.passedEditComment)),
      tempComments: [],
      hoursLoaded: false,
      otHours: null,
      regularHours: null,
      statTime: 0,
      statHoursCount: 0,
      statDaysCount: 0,
      statExemptDaysTotal: 0,
      statExemptHoursTotal: 0,
      approvedVals: {
        approved: this.approved,
        dateApproved: this.dateApproved
      },
      jobSpecificHoursSummary: { regular: {}, ot: {} },

      // mapLocation: latLng(47.41322, -1.219482),
      mapDialogOpen: false,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      showComment: false,
      addComment: {
        comment: null,
        commentBy: null,
        commentDate: null,
        error: false,
        errorMessage: null,
        showCommentScreen: false
      },
      pickerOptions: {
        disabledDate(time) {
          //only allow the date of the time card and the follow day to be picked.
          return (
            time < new Date(vm.date) ||
            time >
              new Date(
                moment(vm.date)
                  .add('days', 1)
                  .endOf('day')
              )
          );
        }
        // onPick(time){
        //     //get the selected day, and concatenate it to the already populated time.
        //     //this will disable dates more than 1 week and enables/disables the Saturday option.
        //     // if(time.maxDate == null || (time.maxDate != null && time.minDate != null)){
        //     //     if(time.maxDate == null){
        //     //         //this means the start date is selected.
        //     //         this.maxDate = moment(time.minDate, 'MMM DD, YY').add(1, 'days');
        //     //         this.minDate = moment(time.minDate, 'MMM DD, YY');
        //     //     }
        //     //     else{
        //     //         this.minDate = undefined;
        //     //         this.maxDate = undefined;
        //     //         //disabledDays = [1,2,3,4,5];
        //     //     }
        //     // }
        //     // else{
        //     //     //disabledDays = [1,2,3,4,5,6];
        //     // }
        // },
      },
      showCloseConfirmation: false,
      propsTimes: this.times,
      tempPassedEditComment: this.passedEditComment,
      tempIncomplete: this.incomplete,
      isTimeOverlaped: false,
      allUserTimeCardsTimes: [],
      timeOverlaps: null,
      modalName: null,
      editCommentReasonTitle: null,
    };
  },
  methods: {
    //kiefer- function to grab icons for leaflet map and color them red and green
    getIcon(item) {
      return L.divIcon({
        className: 'my-custom-pin',
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="16.5 30 20 34.892337" height="30" width="40">
                <g transform="translate(-814.59595,-274.38623)">
                  <g transform="matrix(1.1855854,0,0,1.1855854,-151.17715,-57.3976)">
                    <path d="m 817.11249,282.97118 c -1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867 0.0639,3.84476 1.79693,5.3002 4.56836,10.59179 0.99832,2.32851 2.04027,4.79237 3.03125,8.87305 0.13772,0.60193 0.27203,1.16104 0.33416,1.20948 0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455 0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109 2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918 0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062 -1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655 -2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162 z" style="fill:${item.color};stroke:${item.strokeColor};"/>
                    <circle r="3.0355" cy="288.25278" cx="823.03064" id="path3049" style="display:inline;fill:${item.circleColor};"/>
                  </g>
                </g>
              </svg>`
      });
    },
    updateApproved() {
      //set the time card as approved.
      db.collection('timeCards')
        .doc(this.id)
        .update({
          approved: !this.approvedVals.approved,
          dateApproved: new Date(moment()),
          approvedBy: this.$store.state.userName
        })
        .then(() => {
          this.approvedVals.approved = !this.approvedVals.approved;
          this.approvedVals.dateApproved = moment().format('MMM DD, YY hh:mm');
        })
        .catch(() => {
          alert('Error approving time card.');
        });
    },
    editTimeCard: function() {
      //reset the times to the original times, incase the user cancelled their last edit.
      //if there is no end time, then we need to mount the date picker and emit the values.
      this.tempTimes = JSON.parse(JSON.stringify(this.propsTimes));
      this.showEditModal = true;
      this.modalName = "Edit Time Card";
      this.editCommentReasonTitle = "Why was the edit made:";
      if (this.tempIncomplete) {
        //only pass through the start time for the last time.
        //mount the picker, then we can remove the end time/date.
        let i = this.propsTimes.length - 1;
        setTimeout(() => {
          //need to have the emit function in the delay, because it was emiting before the actual component was mounted so the value was being overriden
          this.$refs['datetime_' + i][0].mountPicker();
          //call the emit function to remove the end time.
          this.$refs['datetime_' + i][0].picker.$emit('pick', [
            this.tempTimes[i].times[0],
            undefined
          ]);
        }, 1);
      }
    },
    splitTimeCard: function(index) {
      // this.tempTimes.push(this.tempTimes[index]);
      this.addSplitTime(index);
      let startTime = this.tempTimes[index].times[0];
      let endTime = this.tempTimes[index].times[1];
      let d1 = new Date(startTime);
      let d2 = new Date(endTime);
      var midpointTime = new Date((d1.getTime() + d2.getTime()) / 2);
      let ISOmidpointTime = midpointTime.toISOString();
      this.$refs['datetime_' + index][0].mountPicker();
      this.$refs['datetime_' + index][0].picker.$emit('pick', [
        startTime,
        ISOmidpointTime
      ]);
      this.$nextTick(() => {
        this.$refs[`datetime_${index + 1}`][0].mountPicker(),
          this.$refs[`datetime_${index + 1}`][0].picker.$emit('pick', [
            ISOmidpointTime,
            endTime
          ]);
      });
    },
    deleteTimeCard: function() {
      this.deleteVisible = true;
    },
    confirmDeleteTimeCard: function() {
      this.deleteVisible = false;
      db.collection('timeCards')
        .doc(this.id)
        .delete()
        .then(() => {
          this.showSuccess('Successfully deleted time card.');
          this.$emit('deleteTimeCard', this.index);
          EventBus.$emit('timeCardDeleted');
        })
        .catch(err => {
          this.showError('Error deleting time card.');
        });
    },
    submitTimeCardEdit: function() {
      //check if the values in the edit are good.
      // if (this.validateTimeCardEdit() == true) {
      this.addCommentToList();
      if (this.validateComments()) {
        db.collection('timeCards')
          .doc(this.id)
          .get()
          .then(() => {
            let timesArg = [];
            for (let i = 0; i <= this.tempTimes.length - 1; i++) {
              let updateTimes = {};
              updateTimes.startTime = new Date(this.tempTimes[i].times[0]);
              if (this.tempTimes[i].times[1] != undefined) {
                updateTimes.endTime = new Date(this.tempTimes[i].times[1]);
              }
              updateTimes.type = this.tempTimes[i].type;
              updateTimes.job = this.tempTimes[i].job
                ? this.tempTimes[i].job
                : null;
              if (this.tempTimes[i].notes != undefined) {
                updateTimes.notes = this.tempTimes[i].notes;
              }
              //get the locations if they exist.
              if (this.tempTimes[i].endLocation != undefined) {
                updateTimes.endLocation = {};
                updateTimes.endLocation.latitude = this.tempTimes[
                  i
                ].endLocation.latitude;
                updateTimes.endLocation.longitude = this.tempTimes[
                  i
                ].endLocation.longitude;
              }
              if (this.tempTimes[i].startLocation != undefined) {
                updateTimes.startLocation = {};
                updateTimes.startLocation.latitude = this.tempTimes[
                  i
                ].startLocation.latitude;
                updateTimes.startLocation.longitude = this.tempTimes[
                  i
                ].startLocation.longitude;
              }
              timesArg.push(updateTimes);
            }
            let formattedComments = this.tempComments.map(
              ({ commentDate, ...rest }) => ({
                ...rest,
                commentDate: new Date(commentDate)
              })
            );
            let editData = {};
            if (formattedComments.length > 0) {
              editData = {
                times: timesArg,
                editComment: formattedComments,
                approved: false,
                dateApproved: new Date(moment()),
                approvedBy: this.$store.state.userName
              };
            } else {
              editData = {
                times: timesArg,
                approved: false,
                dateApproved: new Date(moment()),
                approvedBy: this.$store.state.userName
              };
            }
            //udpate the times on the time card.
            db.collection('timeCards')
              .doc(this.id)
              .update(editData)
              .then(() => {
                this.showSuccess('Time card successfully updated.');
                this.closeModal();
                this.propsTimes = JSON.parse(JSON.stringify(this.tempTimes));
                this.propsTimes = JSON.parse(JSON.stringify(this.tempTimes));

                this.tempPassedEditComment =
                  this.tempComments.length > 0 ? this.tempComments : null;

                //check to see if the last time does not have an end time. If it doesn't, then we set to incomplete.
                if (
                  this.tempTimes[this.tempTimes.length - 1].times[1] ==
                  undefined
                ) {
                  this.tempIncomplete = true;
                } else {
                  this.tempIncomplete = false;
                }
                this.approvedVals.approved = false;
                this.approvedVals.dateApproved = moment().format('MMM DD, YY hh:mm'); 


                this.$refs.weeklyOT.calculateOT();
              })
              .catch(err => {
                console.log(`Error updating time card: ${err}`);
                this.showError(`Error updating time card`);
                this.showEditAlert = true;
                this.editTimeCardMessage = 'Error updating time card.';
              });
          })
          .catch(err => {
            console.log(`Error updating time card: ${err}`);
            this.showError(`Error updating time card.`);
            this.showEditAlert = true;
            this.editTimeCardMessage = 'Error updating time card.';
          });
      }
    },
    validateTimeCardEdit: function() {
      let flag = true;
      try {
        for (let i = 0; i < this.tempTimes.length; i++) {
          // Validate that the dates aren't empty
          this.tempTimes[i].dateError = false;

          // Validate the type isn't empty.
          if (this.tempTimes[i].type == null) {
            this.tempTimes[i].typeError = true;
            this.tempTimes[i].typeMessage = 'Type cannot be empty.';
            flag = false;
          } else {
            this.tempTimes[i].typeError = false;
          }

          if (this.tempTimes[i].times) {
            // If it is the last timespan, only check if start time is present
            if (i === this.tempTimes.length - 1) {
              if (!this.tempTimes[i].times[0]) {
                this.tempTimes[i].dateError = true;
                this.tempTimes[i].dateMessage = 'Dates cannot be empty.';
                flag = false;
              }
            }
            // If it is any other timespan, check to make sure both start and end time are present
            else {
              if (!this.tempTimes[i].times[0] || !this.tempTimes[i].times[1]) {
                this.tempTimes[i].dateError = true;
                this.tempTimes[i].dateMessage = 'Dates cannot be empty.';
                flag = false;
              }
            }
          } else {
            this.tempTimes[i].dateError = true;
            this.tempTimes[i].dateMessage = 'Dates cannot be empty.';
            flag = false;
          }
        }
      } catch (err) {
        flag = false;
        this.showError('An unexpected error occurred.');
      }
      return flag;
    },

    validateComments: function() {
      let flag = true;
      try {
        //only do this check if the setting is enabled.
        if (this.$store.state.requireEditComments == 'Yes') {
          //check to make sure the user has left a comment.
          if (
            this.tempComments.length ==
            (this.tempPassedEditComment != null
              ? this.tempPassedEditComment.length
              : 0)
          ) {
            flag = false;
            this.addComment.error = true;
            this.addComment.errorMessage =
              'You must leave a comment to edit a time card.';
          } else {
            this.addComment.error = false;
          }
        }
      } catch (err) {
        flag = false;
        this.showError('An unexpected error ocurred.');
      }
      return flag;
    },
    closeModal: function() {
      this.showEditModal = false;
      this.addComment.showCommentScreen = false;
      this.showInfoModal = false;
      this.showCloseConfirmation = false;
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    },
    addTime: function() {
      if (this.tempTimes[this.tempTimes.length - 1].times) {
        if (
          !this.tempTimes[this.tempTimes.length - 1].times[0] ||
          !this.tempTimes[this.tempTimes.length - 1].times[1]
        ) {
          return;
        }
      } else {
        if (
          !this.tempTimes[this.tempTimes.length - 1].startTime ||
          !this.tempTimes[this.tempTimes.length - 1].endTime
        ) {
          return;
        }
      }
      this.tempTimes.push({
        startTime: '',
        endTime: ''
      });
    },
    addSplitTime: function(index) {
      this.tempTimes.splice(index + 1, 0, {
        startTime: '',
        endTime: '',
        type: this.tempTimes[index].type,
        job: this.tempTimes[index].job
      });
    },
    removeTime: function(index) {
      this.tempTimes.splice(index, 1);
    },
    getStatPayout: async function(startDate, endDate, lastWeek) {
      //get the last 4 weeks.
      //run out to the store and grab a pack of time cards.
      let regularTimeCount = 0;
      //create a counter to see how many timecards in our collection have regular time on them.
      let timeCardsWithRegularTime = 0;
      let timeCards;
      //create a counter for cards that are stat exempt
      let statExemptTime = 0;
      let statExemptDays = 0;
      await db
        .collection('timeCards')
        .where('date', '>=', startDate)
        .where('date', '<=', endDate)
        .where('user', '==', this.uid)
        .where('company', '==', this.$store.state.userCompany)
        .where('approved', '==', true)
        .orderBy('date', 'asc')
        .get()
        .then(querySnapshot => {
          let tempArg = [];
          querySnapshot.forEach(doc => {
            let complete = true;
            for (let i = 0; i <= doc.data().times.length - 1; i++) {
              if (doc.data().times[i].endTime == null) {
                complete = false;
              }
            }
            if (complete) {
              //only going to display time cards that have an end time.
              tempArg.push({
                id: doc.id,
                date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                times: doc.data().times,
                approved: doc.data().approved,
                approvedBy:
                  doc.data().approvedBy == undefined
                    ? null
                    : doc.data().approvedBy,
                name: doc.data().name,
                type: doc.data().type,
                // category: doc.data().category,
                dateApproved:
                  doc.data().dateApproved == undefined
                    ? null
                    : moment(doc.data().dateApproved.toDate()).format(
                        'MMM DD, YY hh:mm'
                      ),
                averagingAgreement: doc.data().averagingAgreement
                  ? doc.data().averagingAgreement
                  : null
              });
            }
          });
          //get the ot status and index of the time cards. This will also give us a list of time cards for the date range selected.
          timeCards = parseTimeCards(tempArg, this.holidays);
          for (let i = 0; i <= timeCards.timeCardCollection.length - 1; i++) {
            // if (lastWeek != undefined) { //this is the last week of timecards that we will check for the stat pay calculation
            //   if (
            //     !moment(timeCards.timeCardCollection[i].date).isBefore(
            //       lastWeek
            //     )
            //   ) {
            //     let override = overRideValues(
            //       timeCards.timeCardCollection[i].times
            //     );
            //     let total = totalTime(
            //       timeCards.timeCardCollection[i].times
            //     );
            //     regularTimeCount += parseFloat(
            //       regularTime(
            //         timeCards.timeCardCollection[i].date,
            //         timeCards.timeCardCollection[i].type,
            //         timeCards.otIndex,
            //         i,
            //         timeCards.lastRegTime,
            //         override,
            //         total,
            //         this.holidays
            //       )
            //     );
            //   }
            // } else {
            let override = overRideValues(
              timeCards.timeCardCollection[i].times,
              timeCards.timeCardCollection[i].type
            );
            statExemptTime += override.otStatExempt;
            if (timeCards.timeCardCollection[i].type === 'employee') {
              if (override.statExemptTime >= 8) {
                statExemptTime += 8;
              } else {
                statExemptTime += override.statExemptTime;
              }
            } else if (
              timeCards.timeCardCollection[i].type === 'driver' ||
              timeCards.timeCardCollection[i].type == 'crusher crew'
            ) {
              if (override.statExemptTime >= 10) {
                statExemptTime += 10;
              } else {
                statExemptTime += override.statExemptTime;
              }
            }
            let total = totalTime(timeCards.timeCardCollection[i].times);
            let timeCardRegularTime = parseFloat(
              regularTime(
                timeCards.timeCardCollection[i].date,
                timeCards.timeCardCollection[i].type,
                timeCards.otIndex,
                i,
                timeCards.lastRegTime,
                override,
                total,
                this.holidays
              )
            );

            regularTimeCount += timeCardRegularTime;
            if (timeCardRegularTime > 0) {
              timeCardsWithRegularTime++;
            }
            statExemptDays += override.statExemptDays;
            this.statExemptDaysTotal += override.statExemptDays;
            this.statExemptHoursTotal +=
              override.statExemptTime + override.otStatExempt;
          }
          // }
        })
        .catch(err => {
          console.log(`Error getting stat holiday data.`, err);
        });
      //! LEAVE THIS HERE. THE AB GOVERNMENT TOOK OUT THE VACATION CALCULATION IN STAT PAY, BUT CAN BE ADDED A FEATURE/OPTION.
      //stat pay in Alberta is calculated as 5% of the last 4 weeks of regular hours and holday pay.
      //so we need to calculate the holiday pay first.
      //holiday (vacation) pay is calcualted as 4% or 6% of the last 4 weeks regualr time worked.
      // let vacationTime = 0;
      // if(this.vacation == '2 weeks'){
      //     vacationTime = regularTimeCount * 0.04;
      // }else if(this.vacation == '3 weeks'){
      //     vacationTime = regularTimeCount * 0.06;
      // }else{
      //     vacationTime = 0;
      // }
      // console.log('Total days with regular time: ', timeCardsWithRegularTime);
      //calculate the stat time now.
      if (timeCards.timeCardCollection.length != 0) {
        // this.statTime += (regularTimeCount + vacationTime) / timeCards.timeCardCollection.length; //this is stat pay with vacation time.
        this.statHoursCount += regularTimeCount - statExemptTime;
        this.statDaysCount += timeCardsWithRegularTime - statExemptDays;
        // this.statDaysCount += timeCards.timeCardCollection.length;
      }
      // console.log('REgular hours', regularTimeCount);
      // console.log('Stat count', this.statHoursCount);
      // console.log('Stat days count', this.statDaysCount);
      if (lastWeek != undefined) {
        this.statTime = (this.statHoursCount / this.statDaysCount).toFixed(2);
        this.$emit(
          'statCalculated',
          this.statTime,
          this.index,
          this.date,
          this.uid,
          this.statHoursCount,
          this.statDaysCount,
          this.statExemptDaysTotal,
          this.statExemptHoursTotal
        );
        //if stat time is a number, update vuex state
        if (!isNaN(this.statTime)) {
          this.$store.commit('updateEmployeeStatTime', {
            employee: this.name,
            time: this.statTime,
            date: this.date
          });
        }
      }
    },
    dateChanged: function(time) {
      //if the calendar is cleared, then we need to go back to the default date limits.
      // console.log(time);
      // if(time == null){
      //     this.maxDate = moment(this.date, 'MMM DD, YY');
      //     this.minDate = moment(this.date, 'MMM DD, YY');
      // }
    },
    removeEndTime: function(index) {
      //remove the selected items end time
      //instead of instantly removing the end time from the times in the database, just remove the end time from the times that are on the teim card component.
      //this will allow the user to cancel the edit, as well as prevent the wrong end time from being deleted.
      //mount the picker, then we can remove the end time/date.
      this.$refs['datetime_' + index][0].mountPicker();
      //call the emit functionto remove the end time.
      this.$refs['datetime_' + index][0].picker.$emit('pick', [
        this.tempTimes[index].times[0],
        undefined
      ]);
    },
    switchToComment: function() {
      //validate the edit. If it is not valid, don't send the user to the comment screen.
      if (this.validateTimeCardEdit()) {
        //loop through and format the dates.
        let comments = [];
        if (this.tempPassedEditComment != null) {
          this.tempPassedEditComment.forEach(comment => {
            comments.push({
              comment: comment.comment,
              commentBy: comment.commentBy,
              commentDate: moment(
                comment.commentDate.nanoseconds != undefined
                  ? comment.commentDate.toDate()
                  : comment.commentDate
              ).format('MMM DD, YY hh:mm A')
            });
          });
          this.tempComments = comments;
        }
        this.addComment.showCommentScreen = true;
      }
    },
    addCommentToList: function() {
      if (
        this.addComment.comment != null ||
        this.addComment.comment != undefined
      ) {
        if (this.addComment.comment.trim() != '') {
          //we aren't going to actually update the comment here, just add it to the list.
          this.tempComments.push({
            comment: this.addComment.comment,
            commentBy: this.$store.state.userName,
            commentDate: moment().format('MMM DD, YY hh:mm A')
          });
          this.addComment.comment = '';
        }
      }
    },
    checkforEnter: function(e) {
      //if the keypressed is enter, then call the add comment function.
      if (e.keyCode === 13) {
        this.addCommentToList();
      }
    },
    updateTimeCardHeader: function(value) {
      this.hasOT = value;
      return;
    },
    fiveOfNineEligible: async function() {
      let flag = false;
      let count = 0;
      let dayOfWeek = moment(this.date).day();
      let startDate = new Date(
        moment(this.date)
          .subtract(63, 'days')
          .calendar()
      );
      let endDate = new Date(moment(this.date).endOf('day'));
      await db
        .collection('timeCards')
        .where('user', '==', this.uid)
        .where('date', '>=', startDate)
        .where('date', '<=', endDate)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(card => {
            3;
            if (moment(card.data().date.toDate()).day() === dayOfWeek) {
              //if a day has only stat exempt time on it, do not count it, otherwise do
              card.data().times.forEach(time => {
                if (time.type !== 'stat exempt' && time.type != 'on call') {
                  flag = true;
                }
              });
              if (flag) {
                count++;
              }
            }
            flag = false;
          });
        })
        .catch(err => {
          console.log('Error calculating 5 of 9 status', err);
        });
      if (count >= 5) {
        return true;
      } else {
        return false;
      }
    },
    formatUtcToMST: function(times) {
      let retTimes = [];
      try {
        if (times[0]) {
          retTimes[0] = moment(times[0])
            .local()
            .format('YYYY-MM-DD HH:mm:ss');
        }
        if(times[1]){
          retTimes[1] = moment(times[1])
            .local()
            .format('YYYY-MM-DD HH:mm:ss');
        }
      } catch (err) {
        console.log(times);
        console.log(retTimes);
        console.log('error parsing times from utc to local');
      }
      return retTimes;
    },
    /*this function calculates the ot hours and regular hours, and will calculate them differently depending on
whether the user has an averaging agreement or not*/
    hoursCalculation: async function() {
      // let index = this.users.findIndex(x => x.id === this.uid);
      // let employeeInUserList = true;
      // if (index === -1) {
      //   employeeInUserList = false;
      // }
      // if (
      //   employeeInUserList &&
      //   this.users[index].averagingAgreement &&
      //   this.id !== 'holiday_temp'
      // ) {
      if (this.averagingAgreement !== null) {
        await this.averagingAgreementCalculation();
        this.hoursLoaded = true;
      } else {
        this.otHours = otTime(
          this.date,
          this.type,
          this.otIndex,
          this.index,
          this.lastRegTime,
          this.overRideValues,
          this.total,
          this.holidays,
          this.averagingAgreement,
          this.uid
        );

        this.regularHours = regularTime(
          this.date,
          this.type,
          this.otIndex,
          this.index,
          this.lastRegTime,
          this.overRideValues,
          this.total,
          this.holidays
        );
        this.hoursLoaded = true;
      }
    },
    /*If the user has an averaging agreement, their regular hours and overtime hours will be calculated by
    this function, which grabs all the time cards for the period of the averaging agreement and calculates
    OT and regular hours based on that*/
    averagingAgreementCalculation: async function() {
      try {
        let agreementData = null;
        let doc = await db
          .collection(
            `companySettings/${this.averagingAgreement.companySettingsID}/averagingAgreements`
          )
          .doc(this.averagingAgreement.docID)
          .get();
        this.averagingAgreementData = doc.data();
        if (!doc.data() || doc.data().deleted) {
          //if the averaging agreement was deleted, calculate the timecard like normal
          this.otHours = otTime(
            this.date,
            this.type,
            this.otIndex,
            this.index,
            this.lastRegTime,
            this.overRideValues,
            this.total,
            this.holidays,
            this.averagingAgreement,
            this.uid
          );
          this.regularHours = regularTime(
            this.date,
            this.type,
            this.otIndex,
            this.index,
            this.lastRegTime,
            this.overRideValues,
            this.total,
            this.holidays
          );
          this.hoursLoaded = true;
          return;
        }
        agreementData = doc.data();
        let startDate;
        this.agreementTimeSpanIndex = agreementData.timeSpans.findIndex(
          x =>
            moment(this.date).format() >=
              moment(x.startDate.toDate()).format() &&
            moment(this.date).format() <= moment(x.endDate.toDate()).format()
        );
        if (this.agreementTimeSpanIndex !== -1) {
          startDate =
            agreementData.timeSpans[this.agreementTimeSpanIndex].startDate;
        } else {
          startDate = agreementData.startDate;
          this.agreementTimeSpanIndex = 0;
        }
        let formattedDate = new Date(
          moment(this.date)
            .subtract(1, 'days')
            .endOf('day')
        );
        // get all timecards between the start date of the agreement and the day before today
        let timeCardsRef = await db
          .collection('timeCards')
          .where('user', '==', this.uid)
          .where('company', '==', this.$store.state.userCompany)
          .where('date', '>=', startDate)
          .where('date', '<=', formattedDate)
          .get();
        let timesArray = [];
        let totalHours = 0;
        for (doc of timeCardsRef.docs) {
          timesArray.push(doc.data());
        }
        // iterate over all cards to get the number of total regular hours worked
        timesArray.forEach(timeCard => {
          if (
              this.holidays.includes(
                moment(new Date(timeCard.date)).format('YYYY-MM-DD')
              )
            ) {
              return;
            }
          let daySum = moment.duration();
          timeCard.times.forEach(time => {
            if (
              time.type !== 'overtime' &&
              time.type !== 'on call' &&
              time.type !== 'travel time'
            ) {
              let start = moment(time.startTime.toDate());
              let end = moment(time.endTime.toDate());
              let span = moment.duration(end.diff(start));
              daySum.add(span)
            }
          });
          //if there is a daily ot specified and the daily total is more than it, only add the daily ot amount(since anything past that will be ot)
          if (agreementData.dailyHoursBeforeOT) {
            if (
              daySum >
              moment.duration(agreementData.dailyHoursBeforeOT, 'hours')
            ) {
              daySum = moment.duration(agreementData.dailyHoursBeforeOT, 'hours')
            }
          } 
          totalHours += Number(roundToQuarter(daySum.asHours()));
        });
        this.agreementTotalHours['previous'] = Number(totalHours);
        //after looping through every time card in the averaging agreement and determining the number of regular
        //hours, we now need to use the result of that: totalHours, to determine what the time spans in this time card will be
        this.regularHours = 0;
        this.otHours = 0;
        this.propsTimes.forEach(time => {
          if (time.times[1] != undefined) {
            let startTime = moment(new Date(time.times[0]));
            let endTime = moment(new Date(time.times[1]));
            startTime.milliseconds(0);
            endTime.milliseconds(0);
            let timeSpan = Number(
              moment.duration(endTime.diff(startTime)).asHours()
            );
            let job = time.job ? time.job : 'default';
            if (this.jobSpecificHoursSummary.regular[`${job}`] === undefined) {
              this.jobSpecificHoursSummary.regular[`${job}`] = 0;
            }
            if (this.jobSpecificHoursSummary.ot[`${job}`] === undefined) {
              this.jobSpecificHoursSummary.ot[`${job}`] = 0;
            }
            //if the timespan is negative, we need to add it to total hours before so that it is calculated into the correct place
            if (timeSpan < 0) {
              totalHours += timeSpan;
            }
            let stat = false;
            if (
              this.holidays.includes(
                moment(new Date(this.date)).format('YYYY-MM-DD')
              )
            ) {
              stat = true;
            }
            if (time.type === 'regular') {
              if (stat) {
                this.otHours = Number(this.otHours) + Number(timeSpan);
                this.jobSpecificHoursSummary.ot[`${job}`] += Number(timeSpan);
              } else if (totalHours >= agreementData.hoursBeforeOT) {
                //if the hours of all the previous time cards are more than the agreement, they are ot hours
                this.otHours = Number(this.otHours) + Number(timeSpan);
                this.jobSpecificHoursSummary.ot[`${job}`] += Number(timeSpan);
              } else if (
                //if the hours of all the previous time cards plus the current timespan are more than the agreement,
                // then some will be regular hours and some will be ot hours
                totalHours + timeSpan >=
                agreementData.hoursBeforeOT
              ) {
                this.otHours =
                  Number(this.otHours) +
                  totalHours +
                  timeSpan -
                  agreementData.hoursBeforeOT;
                this.jobSpecificHoursSummary.ot[`${job}`] +=
                  totalHours + timeSpan - agreementData.hoursBeforeOT;
                this.regularHours =
                  Number(this.regularHours) +
                  timeSpan -
                  (totalHours + timeSpan - agreementData.hoursBeforeOT);
                this.jobSpecificHoursSummary.regular[`${job}`] +=
                  timeSpan -
                  (totalHours + timeSpan - agreementData.hoursBeforeOT);
              } else {
                this.regularHours = Number(this.regularHours) + timeSpan;
                this.jobSpecificHoursSummary.regular[`${job}`] += timeSpan;
              }
            } else if (time.type === 'overtime') {
              this.otHours += timeSpan;
              this.jobSpecificHoursSummary.ot[`${job}`] += timeSpan;
            } else if (time.type === 'ot exempt') {
              this.regularHours += timeSpan;
              this.jobSpecificHoursSummary.regular[`${job}`] += timeSpan;
            } else if (time.type === 'stat exempt') {
              if (stat) {
                this.otHours += timeSpan;
                this.jobSpecificHoursSummary.ot[`${job}`] += timeSpan;
              } else if (totalHours >= agreementData.hoursBeforeOT) {
                this.otHours += timeSpan;
                this.jobSpecificHoursSummary.ot[`${job}`] += timeSpan;
              } else if (totalHours + timeSpan >= agreementData.hoursBeforeOT) {
                this.otHours +=
                  totalHours + timeSpan - agreementData.hoursBeforeOT;
                this.jobSpecificHoursSummary.ot[`${job}`] +=
                  timeSpan - agreementData.hoursBeforeOT;
                this.regularHours +=
                  timeSpan -
                  (totalHours + timeSpan - agreementData.hoursBeforeOT);
                this.jobSpecificHoursSummary.regular[`${job}`] +=
                  timeSpan -
                  (totalHours + timeSpan - agreementData.hoursBeforeOT);
              } else {
                this.regularHours += timeSpan;
                this.jobSpecificHoursSummary.regular[`${job}`] += timeSpan;
              }
            }
            //if the total regular hours is more than the daily hours before ot, add the extra to ot hours and then set the total regular hours to the maximum daily hours before ot value
            if (agreementData.dailyHoursBeforeOT) {
              if (this.regularHours > agreementData.dailyHoursBeforeOT) {
                this.otHours += this.regularHours - agreementData.dailyHoursBeforeOT;
                this.jobSpecificHoursSummary.ot[`${job}`] +=
                  this.regularHours - agreementData.dailyHoursBeforeOT;
                this.regularHours = agreementData.dailyHoursBeforeOT;
              }
            }
            if (timeSpan >= 0) {
              totalHours = Number(totalHours) + timeSpan;
            }
          }
          Object.keys(this.jobSpecificHoursSummary.regular).forEach(key => {
            this.jobSpecificHoursSummary.regular[key] = Number(
              roundToQuarter(Number(this.jobSpecificHoursSummary.regular[key]))
            );
          });
          Object.keys(this.jobSpecificHoursSummary.ot).forEach(key => {
            this.jobSpecificHoursSummary.ot[key] = Number(
              roundToQuarter(Number(this.jobSpecificHoursSummary.ot[key]))
            );
          });
          this.regularHours = Number(roundToQuarter(Number(this.regularHours)));
          this.otHours = Number(roundToQuarter(Number(this.otHours)));
          totalHours = Number(roundToQuarter(Number(totalHours)));
        });
        this.agreementTotalHours['current'] = Number(totalHours);
      } catch (error) {
        console.log(error);
      }
    },
    setWeeklyHours(sum) {
      this.weeklyHours = sum;
    },
    getJobName(id) {
      if (id && id !== 'default') {
        let job = this.jobs.find(x => x.id === id);
        return job.description;
      }
      return 'Unassigned';
    },
    isEndTimeEmpty(index) {
      if (
        this.tempTimes &&
        this.tempTimes[index] &&
        this.tempTimes[index].times &&
        !this.tempTimes[index].times[1]
      ) {
        return true;
      } else {
        return false;
      }
    },
        confirmCloseModal() {
      this.showCloseConfirmation = true;
    },
    handleModalClose() {
      if (this.timeCardEdited) {
        this.confirmCloseModal();
      } else {
        this.closeModal();
      }
    },
    validateTimeSlot(newTimesRange, index) {  
            this.tempTimes[index].timeOverlap = null;
      this.tempTimes[index].times = newTimesRange;

    this.fetchTimeCardsInRange(newTimesRange).then(overlaps => {
      this.timeOverlaps = overlaps;
      const allOverlapsEmpty = Object.values(this.timeOverlaps).every(array => array.length === 0);
            if (allOverlapsEmpty) {
        const startTime1 = new Date(this.tempTimes[index].times[0]).getTime();
        const endTime1 = new Date(this.tempTimes[index].times[1]).getTime();
        
        let messages = [];

        // Check for overlap with other time slots
        for (let j = 0; j < this.tempTimes.length; j++) {
          // Skip the updated time slot
          if (index === j) {
            continue;
          }

          const startTime2 = new Date(this.tempTimes[j].times[0]).getTime();
          const endTime2 = new Date(this.tempTimes[j].times[1]).getTime();

          // If there is an overlap, set the message for the updated time slot only
          if ((startTime1 < endTime2 && endTime1 > startTime2) || 
                (startTime2 < endTime1 && endTime2 > startTime1)) {
            const message = `Overlap with timespan ${j + 1}: ${moment(startTime2).format('YYYY-MM-DD HH:mm:ss')} to ${moment(endTime2).format('YYYY-MM-DD HH:mm:ss')}`;
            messages.push(message);
          }
        }
        // Set the detailed overlap message for the updated time slot only
        if (messages.length > 0) {
          this.tempTimes[index].timeOverlap = messages.join(', ');
          this.isTimeOverlaped = true;
        } else {
          this.isTimeOverlaped = false;
        }
      } 
      
      else {
        // If there are overlaps in the fetched time cards
        this.isTimeOverlaped = true;
        this.tempTimes[index].timeOverlap = overlaps[index].message;
      
      }
    });
  },
  addNewComment() {
      this.modalName = "Add comment";
      this.editCommentReasonTitle = "Add your comment:"
      this.showEditModal = true;
      if (this.tempIncomplete) {
        //since tempIncomplete, the last time span's endTime needs to be set to undefined
        const lastTimeSpanOnCard = this.tempTimes.length - 1;
        this.tempTimes[lastTimeSpanOnCard].times[1] = undefined;
      }
      this.switchToComment()
  },

  async fetchTimeCardsInRange(newTimesRange) {  
    let startDate = new Date(newTimesRange[0]);
    startDate.setHours(0, 0, 0, 0); 

    let endDate = new Date(newTimesRange[1]);
    endDate.setHours(23, 59, 59, 999);

    this.allUserTimeCardsTimes = []; 

      try {
        const querySnapshot = await db
          .collection('timeCards')
          .where('date', '>=', startDate)
          .where('date', '<=', endDate)
          .where('user', '==', this.uid)
          .get();
                querySnapshot.forEach(doc => {

          this.allUserTimeCardsTimes.push(doc.data().times);
        });
        const overlaps = this.findOverlapWithNextDay(newTimesRange)
        return overlaps;
              } catch (err) {
        console.error('Error getting time cards in range.', err);
        throw err;
      }
    },

    findOverlapWithNextDay(selectedDateRange) {
    const selectedStart = new Date(selectedDateRange[0]);
    const selectedEnd = new Date(selectedDateRange[1]);

    let overlaps = [];

    const isNextDayEnd = selectedStart.getDate() !== selectedEnd.getDate() 

    this.allUserTimeCardsTimes.forEach(cardArray => {
        cardArray.forEach(card => {
            const cardStart = new Date(card.startTime.seconds * 1000);
            const cardEnd = new Date(card.endTime.seconds * 1000);

           if(isNextDayEnd) {
                if (cardStart <= selectedEnd && cardEnd > selectedStart) {
                    overlaps.push({
                        cardStart: moment(cardStart).format('YYYY-MM-DD HH:mm:ss'),
                        cardEnd: moment(cardEnd).format('YYYY-MM-DD HH:mm:ss'),
                        message: `The time overlaps with the card of ${moment(selectedEnd).format('MMM DD, YY')}`
                    });
                }
              }
        });
    });

    return overlaps;
}},

  computed: {
    jobSpecificTimes() {
      return this.$store.state.jobSpecificTimes;
    },
    jobs() {
      return this.$store.state.jobs;
    },
    formattedTimes: function() {
      try {
        let retTimes = [];
        for (let i = 0; i <= this.propsTimes.length - 1; i++) {
          retTimes.push({
            startTime: moment(new Date(this.propsTimes[i].times[0])).format(
              'hh:mm a'
            ),
            endTime: this.propsTimes[i].times[1] ? moment(new Date(this.propsTimes[i].times[1])).format(
              'hh:mm a'
            ) : null,
            type:
              this.propsTimes[i].type != undefined &&
              this.propsTimes[i].type != 'regular'
                ? this.propsTimes[i].type
                : '',
            notes: this.propsTimes[i].notes,
            job: this.propsTimes[i].job
          });
        }
        return retTimes;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    editComment: function() {
      let comments = [];
      if (this.tempPassedEditComment != null) {
        this.tempPassedEditComment.forEach(comment => {
          comments.push({
            comment: comment.comment,
            commentBy: comment.commentBy,
            commentDate: moment(
                comment.commentDate.nanoseconds != undefined
                  ? comment.commentDate.toDate()
                  : comment.commentDate
              ).format('MMM DD, YY hh:mm A')
          });
        });
        return comments;
      } else {
        return null;
      }
    },
    total: function() {
      return totalTime(this.propsTimes);
    },
    overRideValues: function() {
      return overRideValues(this.propsTimes);
    },

    travelTime: function() {
      if (!this.tempIncomplete) {
        let daysum = moment.duration();
        for (let t = 0; t <= this.propsTimes.length - 1; t++) {
          if (this.propsTimes[t].type == 'travel time') {
            let start = moment(this.propsTimes[t].times[0]);
            let end = moment(this.propsTimes[t].times[1]);
            daysum.add(moment.duration(end.diff(start)));
          }
        }
        return daysum.asHours().toFixed(2);
      } else {
        return 0;
      }
    },
    onCallHours: function() {
      //if the timecard is incomplete, return 0;
      if (!this.tempIncomplete) {
        let daysum = moment.duration();
        for (let t = 0; t <= this.propsTimes.length - 1; t++) {
          if (this.propsTimes[t].type == 'on call') {
            let start = moment(this.propsTimes[t].times[0]);
            let end = moment(this.propsTimes[t].times[1]);
            daysum.add(moment.duration(end.diff(start)));
          }
        }
        return daysum.asHours().toFixed(2);
      } else {
        return 0;
      }
    },
    storedUser: function() {
      return this.$store.state.userName;
    },
    showIncompleteTimeCards: function() {
      return this.$store.state.showIncompleteTimeCards;
    },
    mapMarkerLocations: function() {
      let markerLocations = [];
      if (this.showLocation) {
        for (let i = 0; i <= this.propsTimes.length - 1; i++) {
          //add the longs and lats to the marker locations. Add the start and end time separately so they have different markers.
          if (
            this.propsTimes[i].startLocation != undefined &&
            this.propsTimes[i].startLocation != null &&
            this.propsTimes[i].startLocation.latitude != undefined &&
            this.propsTimes[i].startLocation.latitude != null
          ) {
            markerLocations.push({
              name: `Clock In Location ${i + 1}`,
              marker: latLng(
                this.propsTimes[i].startLocation.latitude,
                this.propsTimes[i].startLocation.longitude
              ),
              color: 'green'
            });
          }
          if (
            this.propsTimes[i].endLocation != undefined &&
            this.propsTimes[i].endLocation != null &&
            this.propsTimes[i].endLocation.latitude != undefined &&
            this.propsTimes[i].endLocation.latitude != null
          ) {
            markerLocations.push({
              name: `Clock Out Location ${i + 1}`,
              marker: latLng(
                this.propsTimes[i].endLocation.latitude,
                this.propsTimes[i].endLocation.longitude
              ),
              color: 'red'
            });
          }
        }
      }
      return markerLocations;
    },
    timeCardEdited: function() {
      //this function wil check to see if the data inside of the time card has been chagned.
      //returns a bool on the eidted state.
      //comparing this.times to this.tempTimes.

      let timeChanged = false;
      //check that the lengths of both arrays are the same. If they aren't the user has added or deleted a timespan.
      if (this.propsTimes.length != this.tempTimes.length) {
        timeChanged = true;
      } else {
        for (let i = 0; i <= this.propsTimes.length - 1; i++) {
          //compare the timespan type.
          if (this.propsTimes[i].type != this.tempTimes[i].type) {
            timeChanged = true;
            break;
          }
          //compare the timespan job.
          if (this.propsTimes[i].job != this.tempTimes[i].job) {
            timeChanged = true;
            break;
          }
          //comapre the start time.
          if (
            moment(this.propsTimes[i].times[0]).format('YYYY MM DD HH:mm') !=
            moment(this.tempTimes[i].times[0]).format('YYYY MM DD HH:mm')
          ) {
            timeChanged = true;
            break;
          }
          //compare the end time.
          if (
            moment(this.propsTimes[i].times[1]).format('YYYY MM DD HH:mm') !=
            moment(this.tempTimes[i].times[1]).format('YYYY MM DD HH:mm')
          ) {
            //check to see if the time card is incomplete
            //incomplete timecards will have a default this.times endtime of midnight on the day and the this.tempTimes end time of undefined.
            if (
              this.tempIncomplete &&
              this.propsTimes[i].times[1] !=
                moment(this.propsTimes[i].times[1]).format(
                  'YYYY MM DD 23:59'
                ) &&
              this.tempTimes[i].times[1] != undefined
            ) {
              timeChanged = true;
              break;
            } else if (
              !this.tempIncomplete &&
              moment(this.propsTimes[i].times[1]).format('YYYY MM DD HH:mm') !=
                moment(this.tempTimes[i].times[1]).format('YYYY MM DD HH:mm')
            ) {
              timeChanged = true;
              break;
            }
          }
        }
      }
      return timeChanged;
    }
  },
  mounted: async function() {
    await this.hoursCalculation();
    //take the totals that have been computed, update the store, and that will automagically sync with the weekly totals header.
    this.$store.commit('updateTotals', {
      total: this.total,
      reg: this.regularHours,
      ot: this.otHours,
      travel: this.travelTime,
      stat: this.statTime,
      onCall: this.onCallHours
    });
    //check to see if this time card is a stat.
    if (
      this.holidays.includes(moment(new Date(this.date)).format('YYYY-MM-DD'))
    ) {
      this.stat = true;
      let sunday = moment(this.date).startOf('week');
      let getsStatPay = true;
      //check if user is a 5 of 9 employee or if the toggle in settings is set to calculate 5 of 9
      try {
        const user = await db
          .collection('users')
          .doc(this.uid)
          .get();
        if (user.data().type === 'contractor') {
          getsStatPay = false;
        }
        else if (
          user.data().fiveOfNine ||
          this.$store.state.companyFiveOfNine === 'Yes'
        ) {
          getsStatPay = await this.fiveOfNineEligible();
        }
      } catch (error) {
        console.log('Error getting user info', error);
      }
      if (getsStatPay && !this.averagingAgreement) {
        //getting the stat payout for the last 4 weeks previous to the time card.
        for (let i = 1; i <= 4; i++) {
          if (i == 4) {
            this.getStatPayout(
              new Date(
                moment(sunday)
                  .subtract(1, 'days')
                  .startOf('week')
              ),
              new Date(
                moment(sunday)
                  .subtract(1, 'days')
                  .endOf('day')
              ),
              new Date(moment(this.date).subtract(4, 'weeks'))
            );
          } else {
            this.getStatPayout(
              new Date(moment(sunday).subtract(7, 'days')),
              new Date(
                moment(sunday)
                  .subtract(1, 'days')
                  .endOf('day')
              )
            );
            sunday = moment(sunday).subtract(7, 'days');
          }
        }
      } else if (getsStatPay && this.averagingAgreement) {
        //get the last 4 weeks worth of timecards
        await db
          .collection('timeCards')
          .where('date', '>=', new Date(moment(sunday).subtract(4, 'weeks')))
          .where(
            'date',
            '<=',
            new Date(
              moment(sunday)
                .subtract(1, 'days')
                .endOf('day')
            )
          )
          .where('user', '==', this.uid)
          .where('company', '==', this.$store.state.userCompany)
          .where('approved', '==', true)
          .orderBy('date', 'asc')
          .get()
          .then(async querySnapshot => {
            let timeCards = [];
            let averagingAgreementsinTimeFrame = [];
            let allTimecardsHaveAveragingAgreement = true;
            querySnapshot.forEach(doc => {
              let complete = true;
              for (let i = 0; i <= doc.data().times.length - 1; i++) {
                if (doc.data().times[i].endTime == null) {
                  complete = false;
                }
              }
              if (complete) {
                //only going to display time cards that have an end time.
                timeCards.push({
                  id: doc.id,
                  date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                  times: doc.data().times,
                  approved: doc.data().approved,
                  approvedBy:
                    doc.data().approvedBy == undefined
                      ? null
                      : doc.data().approvedBy,
                  name: doc.data().name,
                  type: doc.data().type,
                  // category: doc.data().category,
                  dateApproved:
                    doc.data().dateApproved == undefined
                      ? null
                      : moment(doc.data().dateApproved.toDate()).format(
                          'MMM DD, YY hh:mm'
                        ),
                  averagingAgreement: doc.data().averagingAgreement
                    ? doc.data().averagingAgreement
                    : null,
                  countsTowardsStat: true
                });
              }

              if (
                doc.data().averagingAgreement &&
                !averagingAgreementsinTimeFrame.includes(
                  doc.data().averagingAgreement.docID
                )
              ) {
                averagingAgreementsinTimeFrame.push(
                  doc.data().averagingAgreement.docID
                );
              } else if (!doc.data().averagingAgreement) {
                allTimecardsHaveAveragingAgreement = false;
              }
            });
            // if all timecards are not on the same averaging agreement, display an error
            if (
              averagingAgreementsinTimeFrame.length > 1 ||
              !allTimecardsHaveAveragingAgreement
            ) {
              this.statError =
                'Stat time for employees with averaging agreements can not be calculated unless all time cards within the stat pay period are on the same averaging agreement.';

              this.$emit(
                'statCalculated',
                this.statTime,
                this.index,
                this.date,
                this.uid,
                this.statHoursCount,
                this.statDaysCount,
                this.statExemptDaysTotal,
                this.statExemptHoursTotal,
                this.statError
              );
              return;
            }
            //get the averaging agreement data
            try {
              let agreementData = null;

              let doc = await db
                .collection(
                  `companySettings/${this.averagingAgreement.companySettingsID}/averagingAgreements`
                )
                .doc(averagingAgreementsinTimeFrame[0])
                .get();

              if (!doc.data() || doc.data().deleted) {
                //if the averaging agreement was deleted, calculate the stat like normal

                for (let i = 1; i <= 4; i++) {
                  if (i == 4) {
                    this.getStatPayout(
                      new Date(
                        moment(sunday)
                          .subtract(1, 'days')
                          .startOf('week')
                      ),
                      new Date(
                        moment(sunday)
                          .subtract(1, 'days')
                          .endOf('day')
                      ),
                      new Date(moment(this.date).subtract(4, 'weeks'))
                    );
                  } else {
                    this.getStatPayout(
                      new Date(moment(sunday).subtract(7, 'days')),
                      new Date(
                        moment(sunday)
                          .subtract(1, 'days')
                          .endOf('day')
                      )
                    );
                    sunday = moment(sunday).subtract(7, 'days');
                  }
                }
                return;
              }
              //find the averaging agreement period from the earliest timecard, and get all timecards from that period
              agreementData = doc.data();

              let startDate;
              let agreementTimeSpanIndex;

              agreementTimeSpanIndex = agreementData.timeSpans.findIndex(
                x =>
                  moment(timeCards[0].date).format() >=
                    moment(x.startDate.toDate()).format() &&
                  moment(timeCards[0].date).format() <=
                    moment(x.endDate.toDate()).format()
              );

              if (agreementTimeSpanIndex !== -1) {
                startDate =
                  agreementData.timeSpans[agreementTimeSpanIndex].startDate;
              } else {
                startDate = agreementData.timeSpans[0].startDate;
                agreementTimeSpanIndex = 0;
              }

              let formattedDate = new Date(
                moment(timeCards[0].date)
                  .subtract(1, 'days')
                  .endOf('day')
              );
              let timeCardsRef = await db
                .collection('timeCards')
                .where('user', '==', this.uid)
                .where('company', '==', this.$store.state.userCompany)
                .where('date', '>=', startDate)
                .where('date', '<=', formattedDate)
                .orderBy('date', 'asc')
                .get();

              let timesArray = [];
              let totalHours = 0;
              let regularHoursSum = 0;
              //we could have timecards in this array that don't count towards stat, because we get all timecards from the earliest agreement time frame, and some of those might not count towards stat
              let timeCardsWithRegularTime = 0;

              for (doc of timeCardsRef.docs) {
                timesArray.push(doc.data());
              }
              const allTimeCards = timesArray.concat(timeCards);
              //add the respective averaging agreement periods to each timecard
              allTimeCards.forEach(card => {
                card.timeSpanIndex = agreementData.timeSpans.findIndex(
                  x =>
                    moment(card.date).format() >=
                      moment(x.startDate.toDate()).format() &&
                    moment(card.date).format() <=
                      moment(x.endDate.toDate()).format()
                );
              });
              let previousAgreementSpan;
              //iterate over all cards to get the number of total regular hours worked
              allTimeCards.forEach(timeCard => {
                let timeCardHasRegularTime = false;
                //if we enter into a different averaging agreement timeframe, we reset the hours total to 0
                if (timeCard.timeSpanIndex !== previousAgreementSpan) {
                  regularHoursSum = 0;
                }
                let daySum = moment.duration();

                timeCard.times.forEach(time => {
                  if (
                    time.type !== 'overtime' &&
                    time.type !== 'on call' &&
                    time.type !== 'travel time' &&
                    time.type !== 'stat exempt'
                  ) {
                    //if there is a daily ot specified and the timespan is more than it, only add the daily ot amount(since anything past that will be ot)
                    let start = moment(time.startTime.toDate());
                    let end = moment(time.endTime.toDate());
                    let span = moment.duration(end.diff(start));

                    if (agreementData.dailyHoursBeforeOT) {
                      if (
                        span >
                        moment.duration(
                          agreementData.dailyHoursBeforeOT,
                          'hours'
                        )
                      ) {
                        daySum.add(
                          moment.duration(
                            agreementData.dailyHoursBeforeOT,
                            'hours'
                          )
                        );
                      } else {
                        daySum.add(span);
                      }
                    } else {
                      daySum.add(span);
                    }
                  }
                });
                if (
                  regularHoursSum + Number(roundToQuarter(daySum.asHours())) <=
                  agreementData.hoursBeforeOT
                ) {
                  if (timeCard.countsTowardsStat) {
                    timeCardHasRegularTime = true;
                    totalHours += Number(roundToQuarter(daySum.asHours()));
                    regularHoursSum += Number(roundToQuarter(daySum.asHours()));
                  }
                } else if (
                  regularHoursSum < agreementData.hoursBeforeOT &&
                  regularHoursSum + Number(roundToQuarter(daySum.asHours())) >=
                    agreementData.hoursBeforeOT
                ) {
                  if (timeCard.countsTowardsStat) {
                    timeCardHasRegularTime = true;
                    totalHours += agreementData.hoursBeforeOT - regularHoursSum;

                    regularHoursSum +=
                      agreementData.hoursBeforeOT - regularHoursSum;
                  }
                }
                if (timeCardHasRegularTime) {
                  timeCardsWithRegularTime++;
                }

                previousAgreementSpan = timeCard.timeSpanIndex;
              });

              //set the stat and emit all totals

              this.statDaysCount = timeCardsWithRegularTime;
              this.statHoursCount = totalHours;

              this.statTime = (
                this.statHoursCount / this.statDaysCount
              ).toFixed(2);
              this.$emit(
                'statCalculated',
                this.statTime,
                this.index,
                this.date,
                this.uid,
                this.statHoursCount,
                this.statDaysCount,
                this.statExemptDaysTotal,
                this.statExemptHoursTotal,
                this.statError
              );
              //if stat time is a number, update vuex state
              if (!isNaN(this.statTime)) {
                this.$store.commit('updateEmployeeStatTime', {
                  employee: this.name,
                  time: this.statTime,
                  date: this.date
                });
              }
            } catch (error) {
              console.log(error);
            }
          })
          .catch(err => {
            console.log(`Error getting stat holiday data.`, err);
          });
      }
    }
      },
  watch: {
    tempTimes: {
      handler: 'validateTimeCardEdit',
      deep: true
        }
  }
};
</script>
<style scoped>
.disabled {
  pointer-events: none;
}
.wrapper {
  cursor: not-allowed;
}
</style>